import LinkedIn from "./LinkedIN.svg"
import Twitter from "./Twitter.svg"
import Youtube from "./Youtube.svg"
import Youtube2 from "./Youtube2.svg"
import Github from "./Github.svg"
import Skype from "./Skype.svg"
import Tag from "./Tag.svg"
import Logo from "./Logo.svg"
import LogoWhite from './LogoWhite.svg'
import EMail from './EMail.svg'
import Phone from './Phone.svg'
import SpinnerPuff from './SpinnerPuff.svg'
import Xing from './Xing.svg'
import Facebook from './Facebook.svg'
import Instagram from './Instagram.svg'
import Spotify from './Spotify.svg'
import World from './World.svg'

export { World, Youtube2, Facebook, Instagram, Spotify, Xing, LinkedIn, Twitter, Github, Youtube, Skype, Tag, Logo, LogoWhite, EMail, Phone, SpinnerPuff }
